import * as mui from '@material-ui/core';

export const APP_MUI_CLASS_PREFIX = 'jurispect';

export const MUI_CLASSNAMES_GENERATOR = mui.createGenerateClassName({
  seed: APP_MUI_CLASS_PREFIX
});
